module.exports = __webpack_public_path__ + "static/img/Blue_Arrow_PNG.15fec61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Blue_Arrow_PNG.png
// module id = CUBd
// module chunks = 3